import { DayOfTheWeek, PromoBanner } from '@box-types';

export const weekDays: DayOfTheWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function normalizePromoBanner(promoBanner: PromoBanner): PromoBanner {
  return {
    ...promoBanner,
    available: promoBanner.available ?? true,
    enabled: promoBanner.enabled ?? true,
    enabledOnWeekDays: promoBanner.enabledOnWeekDays ?? weekDays,
    isPromoted: promoBanner.isPromoted ?? false,
    isLandingPageOnly: promoBanner.isLandingPageOnly ?? false,
    opensAutomatically: promoBanner.opensAutomatically ?? false,
    detailsTitle: promoBanner.detailsTitle ?? '',
    segments: promoBanner.segments ?? [],
    notEligibleForSegments: promoBanner.notEligibleForSegments ?? [],
    areas: promoBanner.areas ?? [],
    shops: promoBanner.shops ?? [],
    ineligibleShops: promoBanner.ineligibleShops ?? [],
    cuisines: promoBanner.cuisines ?? [],
    primaryOrSecondaryCuisines: promoBanner.primaryOrSecondaryCuisines ?? [],
    offerKinds: promoBanner.offerKinds ?? [],
    chains: promoBanner.chains ?? [],
    shopCampaigns: promoBanner.shopCampaigns ?? [],
    visibleOnlyWhenShopsFound: promoBanner.visibleOnlyWhenShopsFound ?? false,
    position: promoBanner.position ?? 0,
    displayDaasShops: promoBanner.displayDaasShops ?? false,
    limitResultsToDaas: promoBanner.limitResultsToDaas ?? false,
    eligibleCouponSynergies: promoBanner.eligibleCouponSynergies ?? [],
    notEligibleCouponSynergies: promoBanner.notEligibleCouponSynergies ?? []
  };
}

export { normalizePromoBanner };
